import { SuperBit_swaggerClient, ElementaryPolicyModel} from './superbit-api-models'
import {SimulatorPageModel,LeadModel,VehicleDataModel,SimulatorOfferModel} from './superbit-api-models'
import {GovData1,GovData2, ManulApiModel} from './ManulApiModel'
import generalSettings from '../json/general-settings.json';
import { json } from 'stream/consumers';


export class ElementaryPolicyStatusModel{
    client:any;
    testClient:any;
    serverTestClient:any;
    
    constructor() {

        const apiUrl = localStorage.getItem('apiUrl');
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
       
        this.client = new SuperBit_swaggerClient(url);
        this.testClient = new SuperBit_swaggerClient(url);//("https://api.superbit.co.il");
        this.testClient = new SuperBit_swaggerClient//("https://api.superbit.co.il");
        // this.serverTestClient = new SuperBit_swaggerClient(url);//("https://api.superbit.co.il");
    }

    async signingUpdate(productionData: any) {
        return await this.client.SigningUpdate(productionData);
    }

    async signingUpdate2(productionData: any) {
        return await this.client.SigningUpdate2(productionData);
    }

    async sendSigningComment(commentData: any) {
        return await this.client.treatmentsUpsertCommentTreatment(commentData);
    }
}

